import axios from "axios";
import { API_BASE_URL } from "./apiBase";
const agent = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

agent.interceptors.request.use((config) => {
  const token = localStorage.getItem("userToken");
  if (!token) {
    return config;
  }

  if (typeof window !== "undefined" || process.browser) {
    config = {
      ...config,
      headers: { ...config.headers, Authorization: `Bearer ${token}` },
    };
  }

  return config;
});

let isLoggingOut = false;
const handleLogout = () => {
  localStorage.removeItem("persist:root");
  localStorage.removeItem("userToken");
  localStorage.removeItem("authToken");
  localStorage.removeItem("profileImage");
  localStorage.removeItem("profile_img");
  localStorage.removeItem("userId");

  if (typeof window !== "undefined" && window.location.pathname !== "/login") {
    if (!isLoggingOut) {
      isLoggingOut = true;
      window.location.href = "/login";
    }
  }
};

const isAuthUrl = (url) => {
  if (!url) return false;
  return (
    url === "login" ||
    url.endsWith("/login") ||
    url === "register" ||
    url.endsWith("/register") ||
    url.includes("forgotPassword") ||
    url.includes("resetPassword")
  );
};

agent.interceptors.response.use(
  function (response) {
    if (response?.data?.status === 401 && !isAuthUrl(response?.config?.url)) {
      handleLogout();
      return Promise.reject(response.data);
    }
    return response;
  },
  function (error) {
    const status = error?.response?.status || error?.response?.data?.status;
    const message = error?.response?.data?.message;
    const isUnauthenticated =
      status === 401 ||
      message === "Unauthenticated." ||
      message === "Unauthorized";

    if (isUnauthenticated && !isAuthUrl(error?.config?.url)) {
      handleLogout();
    }
    return Promise.reject(error?.response?.data || error);
  }
);

export { agent };
